import { z } from 'zod'

export const GetMarketplaceLiquidityQuery = z.object({
  date: z.string().date(),
  exchangeId: z.string().nullish(),
  orderBook: z.string().nullish(),
  daysLookback: z.coerce.number().int().positive().optional(),
})

export type GetMarketplaceLiquidityQueryType = z.infer<typeof GetMarketplaceLiquidityQuery>

export const GetMarketplaceLiquidityResult = z.array(
  z.object({
    timestamp: z.string(),
    price: z.number().safe(),
    costToMoveDown: z.number().safe(),
    costToMoveUp: z.number().safe(),
    spread: z.number().safe().nullable(),
  }),
)

export const GetProjectExchangesResult = z.array(
  z.object({
    id: z.string().nullable(),
    name: z.string().nullish(),
    logoUrl: z.string().nullish(),
  }),
)
export type GetProjectExchangesResultType = z.infer<typeof GetProjectExchangesResult>

export const GetProjectTradingPairsQuery = z.object({
  exchangeId: z.string().optional(),
  date: z.string().date(),
  daysLookback: z.coerce.number().int().positive().optional(),
})
export type GetProjectTradingPairsQueryType = z.infer<typeof GetProjectTradingPairsQuery>

export const GetProjectTradingPairsResult = z.array(z.string())
export type GetProjectTradingPairsResultType = z.infer<typeof GetProjectTradingPairsResult>
